import actionTypes from './actionTypes';
import api from 'src/utils/api';
import { getUTCDate } from 'src/utils/date';
import * as log from 'loglevel';

export const fetchNumbers = () => {
  return async dispatch => {
    dispatch({ type: actionTypes.FETCH_HOME_NUMBERS });

    try {
      const {
        data: { interactionsLast30Days, interactionsLast31Days, peopleLast30Days, peopleLast31Days },
      } = await api.getPublic('stats/homepage');

      const peoplePerDay = peopleLast31Days - peopleLast30Days;
      const peoplePerSecond = peoplePerDay / 24 / 60 / 60;

      const interactionsPerDay = interactionsLast31Days - interactionsLast30Days;
      const interactionsPerSecond = interactionsPerDay / 24 / 60 / 60;

      const numbers = {
        peopleCount: calculateCurrentNumber(peopleLast30Days, peoplePerSecond),
        initialPeopleCount: peopleLast30Days,
        interactionCount: calculateCurrentNumber(interactionsLast30Days, interactionsPerSecond),
        initialInteractionCount: interactionsLast30Days,
        interactionsPerSecond,
        peoplePerSecond,
      };

      dispatch({
        type: actionTypes.FETCH_HOME_NUMBERS_SUCCESS,
        numbers,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({
        type: actionTypes.FETCH_HOME_NUMBERS_FAILURE,
        error: ex,
      });
    }
  };
};

export const recalculateNumbers = () => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.RECALCULATE_HOME_NUMBERS });

    try {
      const {
        pages: {
          home: {
            numbers: {
              initialPeopleCount,
              peopleCount: currentPeopleCount,
              initialInteractionCount,
              interactionCount: currentInteractionCount,
              peoplePerSecond,
              interactionsPerSecond,
            },
          },
        },
      } = getState();

      const peopleCount =
        Math.random() < 0.25
          ? calculateCurrentNumber(initialPeopleCount, peoplePerSecond)
          : currentPeopleCount;
      const interactionCount =
        Math.random() < 0.25
          ? calculateCurrentNumber(initialInteractionCount, interactionsPerSecond)
          : currentInteractionCount;

      dispatch({
        type: actionTypes.RECALCULATE_HOME_NUMBERS_SUCCESS,
        peopleCount,
        interactionCount,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({
        type: actionTypes.RECALCULATE_HOME_NUMBERS_FAILURE,
        error: ex,
      });
    }
  };
};

const calculateCurrentNumber = (initialNumber, ratePerSecond) => {
  const today = getUTCDate();
  const hoursInSeconds = today.getHours() * 3600;
  const minutesInSeconds = today.getMinutes() * 60;
  const secondsInDay = hoursInSeconds + minutesInSeconds + today.getSeconds();
  return initialNumber + secondsInDay * ratePerSecond;
};
